import React from 'react'

const SubCatBoxDisplay = ({ item }) => {
    return (
        <div className='col-lg-3 col-md-4 col-12'>
            <a href={`/investors/${item?.slug}`}>
            <div className='card mb-3 p-3 bg-white shadow-sm'>
                <div className='text-center mb-3 mt-3 investor-icon-subcat-wrap'><img src={item?.image} alt='' className="investor-icon-subcat" /></div>
                <h5 className='f14 text-capitalize mb-3 text-center txtred'>{item?.name}</h5>
            </div>
            </a>
        </div>

    )
}

export default SubCatBoxDisplay